import { type ThemeColorModes } from '@atlaskit/tokens';

import type { ActiveTheme } from './types';

export const normaliseThemeColorMode: (
	theme: ActiveTheme | undefined,
) => Exclude<ThemeColorModes, 'auto'> = (
	theme: ActiveTheme | undefined,
): Exclude<ThemeColorModes, 'auto'> => (theme?.colorMode ? theme.colorMode : 'light');
